import { Button, ModalV2, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';

const inputCls =
  'h-[38px] w-full border border-[#D2D8DF] rounded-lg px-3 text-[13px] text-[#353E4A] bg-white focus:outline-none focus:ring-2 focus:ring-[#FA3F58]/20';
const labelCls = 'text-[10px] font-semibold text-[#97A3B5] uppercase tracking-wide';

/** Add a domain to the spam blocklist. Domains are add/delete only — no edit. */
const DomainModal = ({ visible, onClose, onSubmit, submitting }) => {
  const [text, setText] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (visible) {
      setText('');
      setError(null);
    }
  }, [visible]);

  const handleSubmit = () => {
    const trimmed = text.trim();
    if (!trimmed) {
      setError('Domain is required.');
      return;
    }
    onSubmit({ domain: trimmed });
  };

  return (
    <ModalV2
      visible={visible}
      closeModal={onClose}
      width="420px"
      header={
        <Text h4 bold marg="0">
          Add domain
        </Text>
      }
    >
      <div className="flex flex-col gap-4 p-6">
        <div className="flex flex-col gap-1">
          <label className={labelCls}>Domain</label>
          <input
            type="text"
            value={text}
            onChange={(e) => {
              setText(e.target.value);
              setError(null);
            }}
            onKeyDown={(e) => e.key === 'Enter' && !submitting && handleSubmit()}
            placeholder="bit.ly or https://bit.ly/xyz"
            className={`${inputCls} font-mono`}
            autoFocus
          />
          <Text c1 col={theme.GREY_50} marg="2px 0 0" style={{ fontSize: '11px' }}>
            Paste a bare domain or a full link — the protocol, path, and "www." are stripped
            automatically. Any link to this domain (or a subdomain of it) blocks the post instantly.
          </Text>
        </div>

        {error && (
          <Text c1 col={theme.SECONDARY} marg="0" style={{ fontSize: '12px' }}>
            {error}
          </Text>
        )}

        <div className="flex justify-end items-center gap-2 mt-2">
          <button
            type="button"
            onClick={onClose}
            className="h-[32px] px-4 rounded-full border border-[#D2D8DF] text-[13px] text-[#5F6F86] font-medium hover:bg-[#F0F2F4] transition-colors"
          >
            Cancel
          </button>
          <Button
            text="Add domain"
            bg={theme.SECONDARY}
            small
            wid="120px"
            loading={submitting}
            disabled={submitting}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </ModalV2>
  );
};

export default DomainModal;
